import { ScreenerResults } from 'domains/signup/screener/data/results';

/** note(juan): should be updated anytime the ScreenerResults type changes, in order to prevent loading old data with a different contract */
const SCREENER_RESULTS_STORAGE_VERSION = 'v1.2';

export type ScreenerResultsStorage = {
  version: typeof SCREENER_RESULTS_STORAGE_VERSION;
  results: ScreenerResults;
};

const SCREENER_RESULTS_LS_KEY = 'screener-results';

export const getScreenerResultsStoragePair = (results: ScreenerResults): [string, string] => {
  const value = JSON.stringify({
    version: 'v1.2',
    results,
  } as ScreenerResultsStorage);

  return [SCREENER_RESULTS_LS_KEY, value];
};

export const saveResultsToStorage = (results: ScreenerResults) => {
  localStorage.setItem(...getScreenerResultsStoragePair(results));
};

export const loadScreenerResults = (): ScreenerResults | null => {
  const storageString = localStorage.getItem(SCREENER_RESULTS_LS_KEY);

  if (!storageString) {
    return null;
  }
  const data: ScreenerResultsStorage = JSON.parse(storageString);

  if (data.version !== SCREENER_RESULTS_STORAGE_VERSION) {
    return null;
  }

  return data.results;
};
